<div class="row animated fadeIn m-1">
  <div formGroupName="serviceInfo" class="p-fluid">
    <div class="row mb-3">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="4"
                       [title]="'CLIENT_CREATION.SERVICE_INFO.TITLE.SERVICE_INFO' | translate"
                       [description]="'CLIENT_CREATION.SERVICE_INFO.TITLE.SERVICE_INFO_INFO' | translate"
                       [descriptionContainsTags]=true>
      </ibp-form-header>
    </div>
    <div class="row">
      <ibp-form-header class="col-12 mb-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.SERVICE_INFO.TITLE.START_RMA_SERVICE' | translate"
                       [description]="'CLIENT_CREATION.SERVICE_INFO.TITLE.START_RMA_SERVICE_INFO' | translate">
      </ibp-form-header>
      <ibp-calendar formControlName="rmaServiceStartDate"
                    [showIcon]="true"
                    [minDate]="earliestPossibleStartingDate"
                    class="col-6 mb-3"></ibp-calendar>
    </div>
    <div class="row">
      <ibp-form-header class="col-12 my-2"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.SERVICE_INFO.TITLE.ACCOUNTING_PACKAGE' | translate"
                       [description]="'CLIENT_CREATION.SERVICE_INFO.TITLE.ACCOUNTING_PACKAGE_INFO' | translate">
      </ibp-form-header>
      <ibp-package-select class="col-12 mb-2"
                          formControlName="accountingPackage"
                          [billingPackages]="accountingBillingPackage"
                          [packageTitle]="'CLIENT_CREATION.SERVICE_INFO.ACCOUNTING_PACKAGE.TITLE' | translate"
                          [packageCostTitle]="'CLIENT_CREATION.SERVICE_INFO.ACCOUNTING_PACKAGE.COST_TITLE' | translate"
                          [packageAdditionalCostTitle]="'CLIENT_CREATION.SERVICE_INFO.ACCOUNTING_PACKAGE.ADDITIONAL_COST_TITLE' | translate">
      </ibp-package-select>
    </div>
    <div class="row">
      <ibp-form-header class="col-12 mb-2 mt-3"
                       [titleSize]="6"
                       [title]="'CLIENT_CREATION.SERVICE_INFO.TITLE.ADDITIONAL_SERVICES' | translate">
      </ibp-form-header>
      <ibp-checkbox class="col-6 mb-3 flex align-items-center gap-3"
                    [label]="'CLIENT_CREATION.SERVICE_INFO.DOCUMENT_SCANNING_MODULE'"
                    [tooltipText]="'CLIENT_CREATION.SERVICE_INFO.DOCUMENT_SCANNING_MODULE_TOOLTIP'"
                    formControlName="documentScanningModule">
      </ibp-checkbox>
      <ibp-checkbox class="col-6 mb-3 flex align-items-center gap-3"
                    [label]="'CLIENT_CREATION.SERVICE_INFO.EXPENSE_MODULE'"
                    [tooltipText]="'CLIENT_CREATION.SERVICE_INFO.EXPENSE_MODULE_TOOLTIP'"
                    formControlName="expenseAppModule">
      </ibp-checkbox>
      <ibp-checkbox class="col-6 mb-3 flex align-items-center gap-3"
                    [label]="'CLIENT_CREATION.SERVICE_INFO.PAYMENT_WORKFLOW_MODULE'"
                    [tooltipText]="'CLIENT_CREATION.SERVICE_INFO.PAYMENT_WORKFLOW_MODULE_TOOLTIP'"
                    formControlName="paymentWorkflowModule">
      </ibp-checkbox>
      <ibp-checkbox class="col-6 mb-3 flex align-items-center gap-3"
                    [label]="'CLIENT_CREATION.SERVICE_INFO.REFURBISH_DOCUMENTS'"
                    formControlName="refurbishDocuments">
      </ibp-checkbox>
      @if (serviceEnabled$ | async) {
        <ibp-checkbox class="col-6 mb-3 flex align-items-center gap-3"
                      [label]="'CLIENT_CREATION.SERVICE_INFO.ENABLE_PAYROLL_ACCOUNTING_SERVICE'"
                      [tooltipText]="'CLIENT_CREATION.SERVICE_INFO.ENABLE_PAYROLL_ACCOUNTING_SERVICE_TOOLTIP'"
                      formControlName="enablePayrollPackage">
        </ibp-checkbox>
      }
    </div>
    @if (showPayrollPackages()) {
      <div class="row" [@expandCollapse]>
        <ibp-form-header class="col-12 mb-2 mt-3"
                         [titleSize]="6"
                         [title]="'CLIENT_CREATION.SERVICE_INFO.TITLE.PAYROLL_PACKAGE' | translate"
                         [description]="'CLIENT_CREATION.SERVICE_INFO.TITLE.PAYROLL_PACKAGE_INFO' | translate">
        </ibp-form-header>
        <ibp-package-select class="col-12 mb-2"
                            formControlName="payrollPackage"
                            [billingPackages]="payrollBillingPackage"
                            [unselectable]="false"
                            [packageTitle]="'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PACKAGE.TITLE' | translate"
                            [packageCostTitle]="'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PACKAGE.COST_TITLE' | translate"
                            [packageAdditionalCostTitle]="'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PACKAGE.ADDITIONAL_COST_TITLE' | translate">
        </ibp-package-select>
        @if (showPayrollOptions()) {
          <div class="col-12" [@expandCollapse]>
            <div class="row">
              <ibp-input-number [label]="'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PAYMENT_DAY' | translate"
                                formControlName="payrollPayDay"
                                class="col-4 mb-3 mt-2"
                                ibpTooltip
                                [content]="'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PAYMENT_DAY_TOOLTIP' | translate"
                                [min]="1"
                                [max]="31"></ibp-input-number>
              <div class="w-100"></div>
              <ibp-checkbox class="col-12 mb-3 flex align-items-center gap-3"
                            [label]="'CLIENT_CREATION.SERVICE_INFO.EXECUTE_PAYROLL_PAYMENTS'"
                            formControlName="executePayrollPayments">
              </ibp-checkbox>
              <ibp-checkbox class="col-12 mb-3 flex align-items-center gap-3"
                            [label]="'CLIENT_CREATION.SERVICE_INFO.EXECUTE_PAYROLL_PAYMENTS_BEFORE_BANK_HOLIDAYS'"
                            formControlName="executePayrollPaymentsBeforeBankHolidays">
              </ibp-checkbox>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="d-flex pt-4 justify-content-end" style="gap: 20px;">
  <ibp-button [label]="'BTN.BACK'"
              [icon]="['fas', 'chevron-left']"
              (onClick)="prevCallback.emit()">
  </ibp-button>
  <ibp-button [label]="'BTN.CONTINUE'"
              [iconPos]="'right'"
              [disabled]="!isFormValidOrDisabled()"
              [icon]="['fas', 'chevron-right']"
              (onClick)="onNextClick()">
  </ibp-button>
</div>
